<script>
import TemplateProductsListVue from '@/app/modules/contacard/produto/templates/produto/TemplateProductsList.vue';
import UserStoreEditTemplateValueModalVue from '../modals/UserStoreEditTemplateValueModal.vue';
import TemplateProductStoreService from '../../services/TemplateProductStoreService';

export default {
  name: 'UserExpandableGiftCardList',
  extends: TemplateProductsListVue,
  props: {
    row: {
      type: Object,
      default() {
        return {
          id: '',
          storeId: '',
        };
      },
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: TemplateProductStoreService,
    hideTableBottom: true,
    hideEdit: true,
    hideDelete: true,
    showExpand: false,
    extraHeaders: [
      {
        text: '',
        value: 'id',
        component: UserStoreEditTemplateValueModalVue,
      },
    ],
    preHeaders: [
      {
        text: 'Integrador',
        value: 'produtoServicoIntegrador.integrador.nomIntegrador',
      },
    ],
  }),
  computed: {
    productId() {
      return this.row.id;
    },
    storeId() {
      return this.row.storeId || this.value;
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass.list(
        this.makeDefaultParams(params),
      );
    },
    makeDefaultParams(params = {}) {
      return {
        lojaId: this.storeId,
        agrupamentoId: this.productId,
        ...params,
      };
    },
  },
};
</script>
